import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  TenantConfiguration,
  TenantConfigurationControllerApi,
} from "../services";
import { Result, getConfigObject, useBaseData } from "../utils/utils";

interface UseTenantConfigurationProps {
  providerGroupId?: string;
  enabled?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useTenantConfiguration({
  providerGroupId,
  enabled,
}: UseTenantConfigurationProps): useBaseData<TenantConfiguration> {
  return useQuery({
    queryKey: ["tenant-configuration", providerGroupId],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: enabled ?? true,
    queryFn: async () =>
      new TenantConfigurationControllerApi(getConfigObject())
        .getTenantConfiguration(
          providerGroupId //xTENANTID
        )
        .then((it) => it?.data as Result<TenantConfiguration>),
  });
}
